import React from "react";

import { Box, OriginLogo, TrackedLink } from "@origin-digital/ods-core";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@origin-digital/ods-types";
import styled from "styled-components";
import { navigationBarHeight } from "./helpers/consts";
import { IKrakenAuthNavProps } from "./interfaces";

const StyledContainer = styled(Box)<{ noBorder: boolean; isMobile: boolean }>(
  ({ theme: { palette, space }, noBorder, isMobile }) => ({
    paddingLeft: 5,
    paddingRight: 5,
    width: 65,
    height: navigationBarHeight,
    borderRight: `1px solid ${palette.grey["200"]}`,

    ...(noBorder && {
      borderRight: 0,
    }),

    ...(isMobile && {
      paddingLeft: space.medium,
      width: 116,
      display: "flex",
      alignItems: "center",
    }),
  })
);

interface ISmallerLogo extends IKrakenAuthNavProps {
  href: string;
  id: string;
}

const SmallerLogo = ({ href, id, desktopVariant }: ISmallerLogo) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("lg")
  );

  return (
    <StyledContainer
      noBorder={desktopVariant === "slim" || isMobile}
      isMobile={isMobile}
    >
      <TrackedLink
        trackingLabel=""
        trackingType={isMobile ? "mobile-logolink" : "desktop-logolink"}
        href={href}
        id={id}
        data-id={id}
        aria-label="Origin Energy My Account Page"
      >
        <OriginLogo variant={isMobile ? "landscape" : "portrait"} />
      </TrackedLink>
    </StyledContainer>
  );
};

export default SmallerLogo;
